var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterventionRecorded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "intervention_recorded-1",
    d: "M14.6872491,0 L14.7297317,0.00276308838 C14.8672396,0.0208011982 14.9761506,0.12518359 14.9965577,0.257611911 L15,0.302713452 L15,9.38953749 L14.997149,9.43061753 C14.9785359,9.56360649 14.8708138,9.66913839 14.7338898,9.68891488 L14.6872491,9.69225095 L12.5001434,9.69225095 L12.5001434,12.6968696 L12.4972842,12.7379578 C12.4786193,12.8709993 12.3706259,12.9768203 12.2339356,12.9966541 L12.1873925,13 L12.1451509,12.997188 C12.1033463,12.9916041 12.0631215,12.9778244 12.0268923,12.9569296 L11.9920844,12.9337033 L7.81275095,9.69225095 L0.312320753,9.69225095 L0.269936947,9.68948786 C0.132727283,9.67144975 0.0238460871,9.56706736 0.00344194459,9.43463904 L0,9.38953749 L0,0.302713452 L0.00285078128,0.261633414 C0.0214613716,0.128644458 0.129156577,0.0231125574 0.265787811,0.00333606691 L0.312320753,0 L14.6872491,0 Z M12.5001434,6.36073513 L2.4998566,6.36073513 L2.4998566,7.26929245 L12.5001434,7.26929245 L12.5001434,6.36073513 Z M12.5001434,4.24049009 L2.4998566,4.24049009 L2.4998566,5.14904741 L12.5001434,5.14904741 L12.5001434,4.24049009 Z M12.5001434,2.12024504 L2.4998566,2.12024504 L2.4998566,3.02880236 L12.5001434,3.02880236 L12.5001434,2.12024504 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-3",
    transform: "translate(-888.000000, -441.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-4",
    transform: "translate(34.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-5",
    transform: "translate(805.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-6",
    transform: "translate(49.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-7",
    transform: "translate(8.000000, 9.000000)",
    stroke: "#2248C1",
    strokeLinecap: "square",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-8"
  }, /*#__PURE__*/React.createElement("line", {
    id: "intervention_recorded-9",
    x1: 0.416666667,
    y1: 5.4,
    x2: 4.58333333,
    y2: 8.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "intervention_recorded-10",
    x1: 11,
    y1: 0,
    x2: 5.3,
    y2: 7.66666667
  }))), /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "intervention_recorded-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#intervention_recorded-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "intervention_recorded-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#D8D8D8",
    mask: "url(#intervention_recorded-12)",
    points: "-2.8125 13 15 13 15 -1 -2.8125 -1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#2248C1",
    mask: "url(#intervention_recorded-12)",
    points: "-3.75 20 21.5625 20 21.5625 -4 -3.75 -4"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterventionRecorded);
export default __webpack_public_path__ + "static/media/intervention_recorded.d829118adfa79bbb7a58ba3f67f3c7ad.svg";
export { ForwardRef as ReactComponent };